import { render, staticRenderFns } from "./MarketComission.vue?vue&type=template&id=2aea9107&scoped=true"
import script from "./MarketComission.vue?vue&type=script&lang=js"
export * from "./MarketComission.vue?vue&type=script&lang=js"
import style0 from "./MarketComission.vue?vue&type=style&index=0&id=2aea9107&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2aea9107",
  null
  
)

export default component.exports